import { useEffect, useState } from "react";
import Footer from "../../components/footer/footer.component";
import Header from "../../components/header/header.component";
import RootAside from "../../components/root-aside/root-aside";
import FormModal from "./form.modal";
import { AccountService } from "../../services/accounts.service";
import { UtilsService } from "../../services/utils";
import EmptyState from "../../components/empty-state/empty-state.component";
import { Link } from "react-router-dom";
import { AlertService } from "../../services/alert.service";
import ListUsersModal from "./list-users.modal";


declare const KTComponents: any;

export default function RootAccountsPage() {
  const [list, setList] = useState<any[]>([]);

  const [showModal, setShowModal] = useState({
    data: null,
    show: false,
  });
  const [showModalUsers, setShowModalUsers] = useState({
    data: null,
    show: false,
  });

  const handleModal = (refresh?: boolean) => {
    if (refresh) {
      getList();
    }
    setShowModal({ data: null, show: false });
  };

  const getList = async () => {
    const data = await AccountService.list();
    setList(data);
  };

  const disableAccount = async(_id: string) => {
    await AlertService.warning(
      'Desactivar cuenta', 
      'Al desactivar una cuenta, los usuarios no podrán acceder, pero su información se mantendrá guardada.', 
      async () => {
        await AccountService.setStatus(_id, false);
        await getList();

        AlertService.toastSuccess('La cuenta se desactivó exitosamente');
      }
    )
  }

  const enableAccount = async(_id: string) => {
    await AlertService.warning(
      'Activar cuenta', 
      '¿Estás seguro de querer reactivar esta cuenta?', 
      async () => {
        await AccountService.setStatus(_id, true);
        await getList();

        AlertService.toastSuccess('La cuenta se desactivó exitosamente');
      }
    )
  }

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    KTComponents.init();
  }, [list]);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <RootAside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Cuentas
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">
                        Administración
                      </li>
                      <li className="breadcrumb-item text-gray-900">Cuentas</li>
                    </ul>
                  </div>
                  <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowModal({ data: null, show: true })}
                    >
                      <i className="ki-duotone ki-plus"></i> Agregar cuenta
                    </button>
                  </div>
                </div>
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card">
                    {/* <div className="card-header border-0 pt-6">
                      <div className="card-title">
                        <div className="d-flex align-items-center position-relative my-1">
                          <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                            <span className="path1" />
                            <span className="path2" />
                          </i>
                          <input
                            className="form-control form-control-solid w-250px ps-13"
                            placeholder="Buscar usuario"
                            type="text"
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="card-body py-4">
                      <div
                        className="dt-container dt-bootstrap5 dt-empty-footer"
                        id="kt_table_users_wrapper"
                      >
                        <div className="table-responsive" id="">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr
                                className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                                role="row"
                              >
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">ID</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Role: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Nombre</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Estatus</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Plan</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Tipo de pago</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">total usuarios</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span className="">Fecha de creación</span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Actions"
                                  className="text-end min-w-100px dt-orderable-none"
                                  colSpan={1}
                                  rowSpan={1}
                                >
                                  <span className="">Acciones</span>
                                  <span className="dt-column-order" />
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {list.map((row) => (
                                <tr key={row._id}>
                                  <td>{row._id}</td>
                                  <td>
                                    <div className="d-flex flex-column">
                                      <p className="text-gray-800 m-0">
                                        {row.name}
                                      </p>
                                      <span>{row.email}</span>
                                    </div>
                                  </td>
                                  <td>
                                    {row.status ? (
                                      <div className="badge badge-success fw-bold">
                                        Activo
                                      </div>
                                    ) : (
                                      <div className="badge badge-danger fw-bold">
                                        Inactivo
                                      </div>
                                    )}
                                  </td>
                                  <td>{row.plan}</td>
                                  <td>{row.type_plan}</td>
                                  <td>{row.total_users}</td>
                                  <td>
                                    {UtilsService.dateFormat(row.created_at)}
                                  </td>
                                  <td className="text-end">
                                    <button
                                      className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                      data-kt-menu-placement="bottom-end"
                                      data-kt-menu-trigger="click"
                                    >
                                      Acciones
                                      <i className="ki-duotone ki-down fs-5 ms-1" />
                                    </button>
                                    <div
                                      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                      data-kt-menu="true"
                                    >
                                      <div className="menu-item px-3">
                                        <Link
                                          to="."
                                          className="menu-link px-3"
                                          onClick={() =>
                                            setShowModal({
                                              data: row,
                                              show: true,
                                            })
                                          }
                                        >
                                          Editar
                                        </Link>
                                      </div>
                                      <div className="menu-item px-3">
                                        <Link
                                          to="."
                                          className="menu-link px-3"
                                          onClick={() => setShowModalUsers({ show: true, data: row._id })}
                                        >
                                          Usuarios
                                        </Link>
                                      </div>
                                      <div className="menu-item px-3">
                                        {
                                          row.status ? (
                                            <Link to="." className="menu-link px-3 text-start" onClick={() => disableAccount(row._id)}>
                                              Desactivar
                                            </Link>
                                          ) : (
                                            <Link to="." className="menu-link px-3 text-start" onClick={() => enableAccount(row._id)}>
                                              Activar
                                            </Link>
                                          )
                                        }
                                        
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot />
                          </table>

                          {list.length === 0 && <EmptyState />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <FormModal
        show={showModal.show}
        data={showModal.data}
        setShow={handleModal}
      />
      
      <ListUsersModal
        show={showModalUsers.show}
        account={showModalUsers.data}
        setShow={() => setShowModalUsers({ show: false, data: null })}
      />
    </>
  );
}
